import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../app.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-terms-of-use',
  standalone: false,
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.css',
})
export class TermsOfUseComponent {

  blck:any;

  constructor(private route: ActivatedRoute,){
  this.blck = this.route.snapshot.paramMap.get("blk");
  }
 
}

